module.exports = __webpack_public_path__ + "static/Infographic4_2_New_Taipei_mobile-936879b6f99e3d01fc1222a43c7af7db.png";